/**
 * @param  {array} arr     result from cntsInOneCatForPie.js
 * @param  {number} index  which year
 * @return {array}         as below
 */
/*
[{
  name: "Country",
  //colorByPoint: true,
  data: [{
    name: "Canada",
    y: 56.33
  }, {
    name: "Mexico",
    y: 24.03
  }, 
  ...
  ]
}]
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cntsInOneCatForPieEachYear = cntsInOneCatForPieEachYear;
exports.cntsInOneCatForPieEachYearJustY = cntsInOneCatForPieEachYearJustY;

function cntsInOneCatForPieEachYear(arr, index) {

  var output = [];
  output.push({
    name: arr[0].name,
    //colorByPoint: arr[0].colorByPoint,
    data: []
  });

  arr[0].data.forEach(function (d, i) {
    output[0].data[i] = {
      name: d.name,
      y: d.y[index]
    };
  });
  //console.dir(output)
  return output;
}

/**
 * cntsInOneCatForPieEachYearJustY 
 * @param  {array} arr     result from cntsInOneCatForPie.js
 * @param  {number} index  which year
 * @return {array}         as below
 */
/*
[12, 23, 21,...]
 */

function cntsInOneCatForPieEachYearJustY(arr, index) {

  var output = [];
  arr[0].data.forEach(function (d) {
    output.push(d.y[index]);
  });
  return output;
}
//# sourceMappingURL=data:application/json;base64,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